import * as React from 'react';
import { useEffect } from 'react';

import { useTrack } from '@blockworks/platform/services';

/**
 * Tracks to segment; Skips tracking if parameters are null
 *
 * @param eventName
 * @param parameters
 */
const useAnalyticsTrack = (eventName: string, parameters: any | null) => {
    /// Analytics start
    const track = useTrack();
    const trackingData = React.useMemo(() => parameters, [parameters]);

    useEffect(() => {
        // Don't track if trackingData is not defined or if we are in server-side build mode
        if (trackingData === null || typeof window === 'undefined') {
            return;
        }

        track(eventName, trackingData);
    }, [track, eventName, trackingData]);

    return null;
};

export default useAnalyticsTrack;
